// SuccessPage.jsx
import React from 'react';

const SuccessPage = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>🎉 Thank You!</h1>
      <p style={styles.message}>Your form has been successfully submitted.</p>
    </div>
  );
};

const styles = {
  container: {
    height: '100vh',
    display: 'flex',
    backgroundColor: '#f0fff0',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    padding: '2rem',
  },
  heading: {
    fontSize: '3rem',
    color: '#2e7d32',
  },
  message: {
    fontSize: '1.25rem',
    color: '#4caf50',
    marginTop: '1rem',
  },
};

export default SuccessPage;
